.filterRow {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	gap: 4rem;
	height: 40px;
}

.filterButtonWrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
}

.filterLabelWrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	margin: 0 10px;
}

.filterLabel {
	color: #404040;
	font-size: 14px;
	font-weight: 500;
}

.groupedSelectAll {
	padding-right: 1rem;
}

@media (max-width: 768px) {
	.filterRow {
		flex-direction: column;
		height: unset;
		gap: 0.5rem;
	}

	.groupedSelectAll {
		padding-right: unset;
	}
}
